// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".privacy[data-v-effee4c8]{background-color:#fff;font-size:1em;font-weight:400;padding:20px 30px;line-height:2em}.privacy .title[data-v-effee4c8]{text-align:center;font-size:2em;font-weight:700;margin-bottom:1em}.privacy .title-sub[data-v-effee4c8]{font-weight:700;font-size:1.5em;text-align:center}.privacy .indent[data-v-effee4c8]{text-indent:2em}.privacy .text-bold[data-v-effee4c8]{font-weight:700}.privacy .bg-yellow[data-v-effee4c8]{background-color:#f1dd29}", ""]);
// Exports
module.exports = exports;
